import type { ICMDocument } from "../types";
import { createDateColumn, createStringColumn, getMetadataValue } from "./columnHelpers";

const namespace = "icm";

export const icmColumns = [
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.document_number",
        header: "Document Number",
    }),
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.title",
        header: "Title",
        overrides: { size: 300 },
    }),
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.machine_type",
        header: "Machine Type",
    }),
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.document_category",
        header: "Document Category",
        overrides: { size: 200 },
    }),
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.product_line",
        header: "Product Line",
    }),
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.source_type",
        header: "Source Type",
    }),
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.data_source",
        header: "Data Source",
    }),
    createStringColumn<ICMDocument>({
        namespace,
        field: "metadata.reference_table_found",
        header: "Reference Table Found",
        accessor: (row) => (getMetadataValue(row, "metadata.reference_table_found") ? "Yes" : "No"),
    }),
    createDateColumn<ICMDocument>({
        namespace,
        field: "metadata.ingestion_date",
        header: "Ingestion Date",
    }),
];
